/* SS latest reviews (9 Oct 2026)
   Swaps the hard-coded review cards under the buy button (.ss-revs[data-ss-latest])
   for the product's newest 4-5 star Klaviyo Reviews, each with a "x days ago" stamp.
   Uses the same public endpoint as the Klaviyo reviews widget (company YeCKcQ), which
   already groups colour variants. If the request fails or returns nothing, the
   hard-coded cards stay as they are. */
(function () {
  var COMPANY = 'YeCKcQ', SHOW = 3, MAX_CHARS = 150;

  function ago(iso) {
    var s = Math.max(0, (Date.now() - new Date(iso).getTime()) / 1000);
    var m = s / 60, h = m / 60, d = h / 24, w = d / 7, mo = d / 30.44, y = d / 365.25;
    function f(n, u) { n = Math.floor(n); return n + ' ' + u + (n === 1 ? '' : 's') + ' ago'; }
    if (m < 60) return m < 2 ? 'just now' : f(m, 'min');
    if (h < 24) return f(h, 'hour');
    if (d < 7) return f(d, 'day');
    if (w < 5) return f(w, 'week');
    if (mo < 12) return f(mo, 'month');
    return f(y, 'year');
  }

  function el(tag, cls, text) {
    var e = document.createElement(tag);
    if (cls) e.className = cls;
    if (text != null) e.textContent = text;
    return e;
  }

  function card(r) {
    var c = el('div', 'ss-rev ss-rev--live');
    var meta = el('div', 'ss-rev__meta');
    var n = parseInt(r.rating, 10) || 5;
    meta.appendChild(el('span', 'ss-revs__stars', '★★★★★'.slice(0, n) + '☆☆☆☆☆'.slice(0, 5 - n)));
    var who = (r.author || 'Customer') + (String(r.verified) === 'true' ? ' · verified buyer' : '');
    meta.appendChild(el('span', 'ss-rev__name', who));
    meta.appendChild(el('span', 'ss-rev__ago', ago(r.created_at)));
    c.appendChild(meta);
    if (r.title) c.appendChild(el('span', 'ss-rev__title', r.title));
    var body = String(r.content || '').replace(/\s+/g, ' ').trim();
    if (body.length > MAX_CHARS) body = body.slice(0, MAX_CHARS).replace(/\s+\S*$/, '') + '…';
    if (body) c.appendChild(document.createTextNode('“' + body + '”'));
    return c;
  }

  function css() {
    if (document.getElementById('ss-latest-reviews-css')) return;
    var s = el('style');
    s.id = 'ss-latest-reviews-css';
    s.textContent = '.ss-rev--live .ss-rev__meta{display:flex;align-items:baseline;min-width:0}' +
      '.ss-rev--live .ss-rev__name{min-width:0;overflow:hidden;text-overflow:ellipsis;white-space:nowrap}' +
      '.ss-rev__ago{margin-left:auto;padding-left:8px;flex:none;font-size:11px;opacity:.55;white-space:nowrap}';
    document.head.appendChild(s);
  }

  var cache = {};
  function load(box) {
    var pid = box.getAttribute('data-pid');
    var track = box.querySelector('.ss-revs__track');
    if (!pid || !track || box.getAttribute('data-ss-done')) return;
    box.setAttribute('data-ss-done', '1');
    var url = 'https://fast.a.klaviyo.com/reviews/api/client_reviews/' + pid + '/?product_id=' + pid +
      '&company_id=' + COMPANY + '&limit=25&offset=0&sort=1&filter=&type=reviews&media=false&preferred_country=GB';
    var p = cache[pid] || (cache[pid] = fetch(url).then(function (res) { return res.ok ? res.json() : null; }));
    p.then(function (j) {
      var list = (j && j.reviews || []).filter(function (r) {
        return (r.type || 'review') === 'review' && (!r.status || r.status === 'Published') &&
          (parseInt(r.rating, 10) || 0) >= 4 && r.created_at;
      }).sort(function (a, b) { return new Date(b.created_at) - new Date(a.created_at); }).slice(0, SHOW);
      if (!list.length) return;
      css();
      track.innerHTML = '';
      list.forEach(function (r) { track.appendChild(card(r)); });
      track.scrollLeft = 0;
    }).catch(function () {});
  }

  function init() {
    var boxes = document.querySelectorAll('.ss-revs[data-ss-latest]');
    for (var i = 0; i < boxes.length; i++) load(boxes[i]);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  /* the product form can re-render on variant change -> re-apply to fresh copies */
  var t;
  new MutationObserver(function () { clearTimeout(t); t = setTimeout(init, 150); })
    .observe(document.documentElement, { childList: true, subtree: true });
})();
